export default __webpack_public_path__ + "static/Borat-3519dfaa2d9e0c14a3155ce9b592784e.png";